// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import $ from 'jquery';
import myw from 'myWorld/base/core';
import './fieldViewer';

/**
 * Displays a timestamp field value
 * @name HtmlFieldViewer
 * @constructor
 * @extends {FieldViewer}
 */
myw.HtmlFieldViewer = myw.FieldViewer.extend({
    tagName: 'div',

    render() {
        let fieldValue = this.fieldValue;
        if (!fieldValue) return undefined;

        fieldValue = _.unescape(fieldValue)
            .replace('<![CDATA[', '')
            .replace(']]>', '');

        let html = $('<div/>', { html: fieldValue });
        html.find('iframe').remove();
        html.find('style').remove();
        html.find('script').remove();
        this.$el.html(html);
    }
});

export default myw.HtmlFieldViewer;
